import FrontNav from "@/components/FrontNav";
import Footer from "@/components/Footer";
import Head from "next/head";
import Link from "next/link";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "common",
        "frontNav",
        "footer",
      ])),
    },
  };
}
export default function Example() {
  return (
    <div className="bg-white">
      <Head>
        <title>oinkBIT | Privacy Policy</title>
      </Head>

      <FrontNav />

      <main className="isolate max-w-screen-2xl mx-auto p-10 fade-in">
        <div className="flex justify-center items-center flex-col bg-white py-20">
          <h1 className="text-5xl lg:h-14 text-center tracking-tigher bg-gradient-to-r from-gray-600 via-gray-400 to-gray-800 inline-block bg-clip-text text-transparent">
            Privacy Policy.
          </h1>
        </div>
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            1. Information We Collect
          </h2>
          <p className="text-gray-600">
            We collect personal information that you provide to us directly,
            such as your name, email address, phone number, and payment details
            when you sign up for our services.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            2. How We Use Your Information
          </h2>
          <p className="text-gray-600">We use the information we collect to:</p>
          <ul className="list-disc list-inside text-gray-600">
            <li>Provide and maintain our services.</li>
            <li>Process payments and transactions.</li>
            <li>
              Communicate with you about updates, offers, or changes to our
              services.
            </li>
            <li>
              Analyze user behavior to improve our platform and offerings.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            3. Sharing Your Information
          </h2>
          <p className="text-gray-600">
            We may share your information with third parties in the following
            cases:
          </p>
          <ul className="list-disc list-inside text-gray-600">
            <li>
              With service providers who help us operate our platform (e.g.,
              payment processors, hosting providers).
            </li>
            <li>
              To comply with legal obligations or respond to lawful requests.
            </li>
            <li>
              In the event of a business transfer, such as a merger,
              acquisition, or sale of assets.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            4. Data Security
          </h2>
          <p className="text-gray-600">
            We implement security measures to protect your data, including
            encryption and access controls. However, no system is entirely
            secure, and we cannot guarantee the absolute safety of your
            information.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            5. Your Data Rights
          </h2>
          <p className="text-gray-600">
            You have the right to access, update, or delete your personal data.
            To exercise these rights, please contact us at{" "}
            <a
              href="mailto:privacy@kobiworks.com"
              className="text-blue-500 underline"
            >
              privacy@kobiworks.com
            </a>
            . Note that we may retain certain information as required by law or
            for legitimate business purposes.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            6. Cookies and Tracking
          </h2>
          <p className="text-gray-600">
            We use cookies and similar tracking technologies to enhance your
            experience on our platform. Cookies help us remember your
            preferences, analyze usage patterns, and deliver targeted
            advertisements. You can manage or disable cookies in your browser
            settings, but some features of the platform may not function
            properly without them.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            7. Updates to This Policy
          </h2>
          <p className="text-gray-600">
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with an updated revision date. We
            encourage you to review this policy periodically to stay informed
            about how we protect your information.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            8. Contact Us
          </h2>
          <p className="text-gray-600">
            If you have any questions about this Privacy Policy, please contact
            us at{" "}
            <a
              href="mailto:info@kobiworks.com"
              className="text-blue-500 underline"
            >
              info@kobiworks.com
            </a>
            .
          </p>
        </section>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
